(() => {
  function setup(scope = document) {
    const videos = scope.querySelectorAll(
      '.product__media video, .product__media-item video, .product-media-container video'
    );

    videos.forEach((v) => {
      v.muted = true;
      v.defaultMuted = true;
      v.playsInline = true;
      v.loop = true;
      v.autoplay = true;
      v.preload = 'metadata';

      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.setAttribute('loop', '');
      v.setAttribute('autoplay', '');
    });
  }

  function playActive() {
    const active =
      document.querySelector('.product__media-item.is-active video') ||
      document.querySelector('.product__media-item[aria-current="true"] video') ||
      document.querySelector('.product__media video');

    document.querySelectorAll('.product__media video').forEach((v) => {
      if (v !== active) v.pause();
    });

    if (active) active.play().catch(() => {});
  }

  document.addEventListener('DOMContentLoaded', () => {
    setup(document);
    playActive();

    document.addEventListener('click', (e) => {
      if (
        e.target.closest('button') &&
        (e.target.closest('.slider-button') ||
          e.target.closest('.thumbnail') ||
          e.target.closest('[data-media-id]'))
      ) {
        setTimeout(playActive, 50);
      }
    });

    document.addEventListener('keyup', () => setTimeout(playActive, 50));
  });

  document.addEventListener('shopify:section:load', (e) => {
    setup(e.target);
    setTimeout(playActive, 50);
  });
})();
